var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60029 31.6219C3.27496 31.6219 2.97896 31.5659 2.71229 31.4539C2.45096 31.3365 2.22429 31.1765 2.03229 30.9739C1.84029 30.7712 1.69096 30.5392 1.58429 30.2779C1.48296 30.0165 1.43229 29.7392 1.43229 29.4459C1.43229 29.0512 1.52029 28.6912 1.69629 28.3659C1.87763 28.0405 2.12829 27.7792 2.44829 27.5819C2.77363 27.3845 3.15763 27.2859 3.60029 27.2859C4.02696 27.2859 4.39763 27.3819 4.71229 27.5739C5.03229 27.7605 5.26696 28.0112 5.41629 28.3259L4.56029 28.5979C4.46429 28.4219 4.32829 28.2859 4.15229 28.1899C3.98163 28.0885 3.79229 28.0379 3.58429 28.0379C3.34963 28.0379 3.13629 28.0992 2.94429 28.2219C2.75763 28.3392 2.60829 28.5045 2.49629 28.7179C2.38963 28.9259 2.33629 29.1685 2.33629 29.4459C2.33629 29.7125 2.39229 29.9552 2.50429 30.1739C2.61629 30.3872 2.76563 30.5579 2.95229 30.6859C3.14429 30.8085 3.35763 30.8699 3.59229 30.8699C3.73629 30.8699 3.87496 30.8459 4.00829 30.7979C4.14696 30.7445 4.26696 30.6752 4.36829 30.5899C4.46963 30.4992 4.54163 30.4005 4.58429 30.2939L5.44829 30.5499C5.35763 30.7579 5.22163 30.9419 5.04029 31.1019C4.86429 31.2619 4.65363 31.3899 4.40829 31.4859C4.16829 31.5765 3.89896 31.6219 3.60029 31.6219ZM8.01398 31.6219C7.68332 31.6219 7.38732 31.5659 7.12598 31.4539C6.86465 31.3365 6.63798 31.1765 6.44598 30.9739C6.25932 30.7712 6.11532 30.5419 6.01398 30.2859C5.91265 30.0245 5.86198 29.7472 5.86198 29.4539C5.86198 29.1605 5.91265 28.8832 6.01398 28.6219C6.11532 28.3605 6.25932 28.1312 6.44598 27.9339C6.63798 27.7312 6.86465 27.5739 7.12598 27.4619C7.39265 27.3445 7.68865 27.2859 8.01398 27.2859C8.33932 27.2859 8.63265 27.3445 8.89398 27.4619C9.16065 27.5739 9.38732 27.7312 9.57398 27.9339C9.76598 28.1312 9.91265 28.3605 10.014 28.6219C10.1153 28.8832 10.166 29.1605 10.166 29.4539C10.166 29.7472 10.1153 30.0245 10.014 30.2859C9.91265 30.5419 9.76598 30.7712 9.57398 30.9739C9.38732 31.1765 9.16065 31.3365 8.89398 31.4539C8.63265 31.5659 8.33932 31.6219 8.01398 31.6219ZM6.76598 29.4619C6.76598 29.7285 6.82198 29.9685 6.93398 30.1819C7.04598 30.3952 7.19532 30.5632 7.38198 30.6859C7.56865 30.8085 7.77932 30.8699 8.01398 30.8699C8.24332 30.8699 8.45132 30.8085 8.63798 30.6859C8.82998 30.5579 8.98198 30.3872 9.09398 30.1739C9.20598 29.9552 9.26198 29.7152 9.26198 29.4539C9.26198 29.1872 9.20598 28.9472 9.09398 28.7339C8.98198 28.5205 8.82998 28.3525 8.63798 28.2299C8.45132 28.1019 8.24332 28.0379 8.01398 28.0379C7.77932 28.0379 7.56865 28.1019 7.38198 28.2299C7.19532 28.3579 7.04598 28.5285 6.93398 28.7419C6.82198 28.9499 6.76598 29.1899 6.76598 29.4619ZM17.3465 31.5419H16.4665V29.1979C16.4665 28.8085 16.4025 28.5232 16.2745 28.3419C16.1465 28.1605 15.9598 28.0699 15.7145 28.0699C15.4691 28.0699 15.2398 28.1632 15.0265 28.3499C14.8185 28.5312 14.6718 28.7685 14.5865 29.0619V31.5419H13.7065V29.1979C13.7065 28.8085 13.6425 28.5232 13.5145 28.3419C13.3865 28.1605 13.2025 28.0699 12.9625 28.0699C12.7171 28.0699 12.4878 28.1605 12.2745 28.3419C12.0665 28.5232 11.9171 28.7605 11.8265 29.0539V31.5419H10.9465V27.3579H11.7465V28.1979C11.9118 27.9045 12.1278 27.6805 12.3945 27.5259C12.6665 27.3659 12.9758 27.2859 13.3225 27.2859C13.6691 27.2859 13.9411 27.3765 14.1385 27.5579C14.3411 27.7392 14.4665 27.9659 14.5145 28.2379C14.6958 27.9285 14.9171 27.6939 15.1785 27.5339C15.4451 27.3685 15.7491 27.2859 16.0905 27.2859C16.3358 27.2859 16.5411 27.3312 16.7065 27.4219C16.8718 27.5125 16.9998 27.6379 17.0905 27.7979C17.1811 27.9525 17.2451 28.1339 17.2825 28.3419C17.3251 28.5445 17.3465 28.7605 17.3465 28.9899V31.5419Z",
    fill: "#5C595B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7365 31.6219C20.4005 31.6219 20.1045 31.5419 19.8485 31.3819C19.5925 31.2219 19.3899 31.0139 19.2405 30.7579V33.2459H18.3605V27.3579H19.1365V28.1099C19.2965 27.8592 19.5045 27.6592 19.7605 27.5099C20.0165 27.3605 20.3019 27.2859 20.6165 27.2859C20.9045 27.2859 21.1685 27.3445 21.4085 27.4619C21.6485 27.5739 21.8565 27.7312 22.0325 27.9339C22.2085 28.1365 22.3445 28.3685 22.4405 28.6299C22.5419 28.8859 22.5925 29.1579 22.5925 29.4459C22.5925 29.8459 22.5125 30.2112 22.3525 30.5419C22.1979 30.8725 21.9792 31.1365 21.6965 31.3339C21.4192 31.5259 21.0992 31.6219 20.7365 31.6219ZM20.4485 30.8699C20.6352 30.8699 20.8032 30.8299 20.9525 30.7499C21.1072 30.6699 21.2379 30.5632 21.3445 30.4299C21.4565 30.2965 21.5419 30.1445 21.6005 29.9739C21.6592 29.8032 21.6885 29.6272 21.6885 29.4459C21.6885 29.2539 21.6565 29.0725 21.5925 28.9019C21.5285 28.7312 21.4352 28.5819 21.3125 28.4539C21.1952 28.3259 21.0565 28.2245 20.8965 28.1499C20.7419 28.0752 20.5712 28.0379 20.3845 28.0379C20.2725 28.0379 20.1552 28.0592 20.0325 28.1019C19.9099 28.1445 19.7952 28.2032 19.6885 28.2779C19.5819 28.3525 19.4885 28.4405 19.4085 28.5419C19.3285 28.6432 19.2725 28.7499 19.2405 28.8619V29.9579C19.3152 30.1285 19.4139 30.2832 19.5365 30.4219C19.6592 30.5552 19.8005 30.6645 19.9605 30.7499C20.1205 30.8299 20.2832 30.8699 20.4485 30.8699ZM25.736 28.1179C25.3946 28.1232 25.0906 28.2005 24.824 28.3499C24.5626 28.4992 24.376 28.7099 24.264 28.9819V31.5419H23.384V27.3579H24.2V28.2939C24.344 28.0059 24.5333 27.7765 24.768 27.6059C25.0026 27.4299 25.2506 27.3339 25.512 27.3179C25.5653 27.3179 25.608 27.3179 25.64 27.3179C25.6773 27.3179 25.7093 27.3205 25.736 27.3259V28.1179ZM28.178 31.6219C27.8474 31.6219 27.5514 31.5659 27.29 31.4539C27.0287 31.3365 26.802 31.1765 26.61 30.9739C26.4234 30.7712 26.2794 30.5419 26.178 30.2859C26.0767 30.0245 26.026 29.7472 26.026 29.4539C26.026 29.1605 26.0767 28.8832 26.178 28.6219C26.2794 28.3605 26.4234 28.1312 26.61 27.9339C26.802 27.7312 27.0287 27.5739 27.29 27.4619C27.5567 27.3445 27.8527 27.2859 28.178 27.2859C28.5034 27.2859 28.7967 27.3445 29.058 27.4619C29.3247 27.5739 29.5514 27.7312 29.738 27.9339C29.93 28.1312 30.0767 28.3605 30.178 28.6219C30.2794 28.8832 30.33 29.1605 30.33 29.4539C30.33 29.7472 30.2794 30.0245 30.178 30.2859C30.0767 30.5419 29.93 30.7712 29.738 30.9739C29.5514 31.1765 29.3247 31.3365 29.058 31.4539C28.7967 31.5659 28.5034 31.6219 28.178 31.6219ZM26.93 29.4619C26.93 29.7285 26.986 29.9685 27.098 30.1819C27.21 30.3952 27.3594 30.5632 27.546 30.6859C27.7327 30.8085 27.9434 30.8699 28.178 30.8699C28.4074 30.8699 28.6154 30.8085 28.802 30.6859C28.994 30.5579 29.146 30.3872 29.258 30.1739C29.37 29.9552 29.426 29.7152 29.426 29.4539C29.426 29.1872 29.37 28.9472 29.258 28.7339C29.146 28.5205 28.994 28.3525 28.802 28.2299C28.6154 28.1019 28.4074 28.0379 28.178 28.0379C27.9434 28.0379 27.7327 28.1019 27.546 28.2299C27.3594 28.3579 27.21 28.5285 27.098 28.7419C26.986 28.9499 26.93 29.1899 26.93 29.4619ZM33.4865 31.6219C33.1505 31.6219 32.8545 31.5419 32.5985 31.3819C32.3425 31.2219 32.1399 31.0139 31.9905 30.7579V33.2459H31.1105V27.3579H31.8865V28.1099C32.0465 27.8592 32.2545 27.6592 32.5105 27.5099C32.7665 27.3605 33.0519 27.2859 33.3665 27.2859C33.6545 27.2859 33.9185 27.3445 34.1585 27.4619C34.3985 27.5739 34.6065 27.7312 34.7825 27.9339C34.9585 28.1365 35.0945 28.3685 35.1905 28.6299C35.2919 28.8859 35.3425 29.1579 35.3425 29.4459C35.3425 29.8459 35.2625 30.2112 35.1025 30.5419C34.9479 30.8725 34.7292 31.1365 34.4465 31.3339C34.1692 31.5259 33.8492 31.6219 33.4865 31.6219ZM33.1985 30.8699C33.3852 30.8699 33.5532 30.8299 33.7025 30.7499C33.8572 30.6699 33.9879 30.5632 34.0945 30.4299C34.2065 30.2965 34.2919 30.1445 34.3505 29.9739C34.4092 29.8032 34.4385 29.6272 34.4385 29.4459C34.4385 29.2539 34.4065 29.0725 34.3425 28.9019C34.2785 28.7312 34.1852 28.5819 34.0625 28.4539C33.9452 28.3259 33.8065 28.2245 33.6465 28.1499C33.4919 28.0752 33.3212 28.0379 33.1345 28.0379C33.0225 28.0379 32.9052 28.0592 32.7825 28.1019C32.6599 28.1445 32.5452 28.2032 32.4385 28.2779C32.3319 28.3525 32.2385 28.4405 32.1585 28.5419C32.0785 28.6432 32.0225 28.7499 31.9905 28.8619V29.9579C32.0652 30.1285 32.1639 30.2832 32.2865 30.4219C32.4092 30.5552 32.5505 30.6645 32.7105 30.7499C32.8705 30.8299 33.0332 30.8699 33.1985 30.8699ZM37.622 31.6219C37.27 31.6219 36.9366 31.5659 36.622 31.4539C36.3073 31.3365 36.038 31.1632 35.814 30.9339L36.142 30.3419C36.382 30.5552 36.622 30.7099 36.862 30.8059C37.1073 30.9019 37.35 30.9499 37.59 30.9499C37.8353 30.9499 38.0353 30.9045 38.19 30.8139C38.3446 30.7179 38.422 30.5792 38.422 30.3979C38.422 30.2645 38.382 30.1659 38.302 30.1019C38.222 30.0379 38.1046 29.9819 37.95 29.9339C37.8006 29.8859 37.6193 29.8325 37.406 29.7739C37.1073 29.6832 36.8566 29.5899 36.654 29.4939C36.4513 29.3925 36.2993 29.2699 36.198 29.1259C36.0966 28.9819 36.046 28.7979 36.046 28.5739C36.046 28.3019 36.1153 28.0699 36.254 27.8779C36.3926 27.6859 36.5846 27.5392 36.83 27.4379C37.0806 27.3365 37.3686 27.2859 37.694 27.2859C37.998 27.2859 38.278 27.3339 38.534 27.4299C38.7953 27.5205 39.0246 27.6645 39.222 27.8619L38.846 28.4459C38.6593 28.2752 38.4673 28.1499 38.27 28.0699C38.078 27.9899 37.87 27.9499 37.646 27.9499C37.518 27.9499 37.3953 27.9659 37.278 27.9979C37.1606 28.0245 37.062 28.0779 36.982 28.1579C36.9073 28.2325 36.87 28.3392 36.87 28.4779C36.87 28.5899 36.902 28.6805 36.966 28.7499C37.03 28.8192 37.126 28.8779 37.254 28.9259C37.382 28.9739 37.5393 29.0272 37.726 29.0859C38.0513 29.1819 38.3286 29.2779 38.558 29.3739C38.7873 29.4645 38.9633 29.5845 39.086 29.7339C39.214 29.8779 39.278 30.0779 39.278 30.3339C39.278 30.7392 39.126 31.0565 38.822 31.2859C38.5233 31.5099 38.1233 31.6219 37.622 31.6219Z",
    fill: "#2898FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8575 0C18.8575 0 6.32872 5.72335 6.32872 5.9207C6.32872 6.11806 6.26465 9.77621 6.26465 9.77621L13.6609 7.81674L18.8575 9.26167V0Z",
    fill: "url(#paint0_linear_298_4370)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9241 9.39563C13.9881 9.59299 13.9241 14.978 13.9241 14.978L0.0640678 18.1287L0 12.9692L13.9241 9.39563Z",
    fill: "url(#paint1_linear_298_4370)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9751 17.2546C22.0391 17.4449 21.9751 22.8441 21.9751 22.8441L6.16455 21.8291V17.6L21.9751 17.2546Z",
    fill: "url(#paint2_linear_298_4370)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8574 0L34.1127 9.64229L34.134 13.3075L18.8574 9.25462V0Z",
    fill: "url(#paint3_linear_298_4370)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4255 14.6115C32.4255 14.7172 32.5252 17.3251 32.5252 17.3251L13.9526 14.978V9.39563L32.4255 14.6115Z",
    fill: "url(#paint4_linear_298_4370)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9751 17.2546L36.2124 19.2423C36.2124 19.2423 36.4188 22.8088 36.3192 22.7665C36.2195 22.7242 22.0107 22.83 22.0107 22.83L21.9751 17.2546Z",
    fill: "url(#paint5_linear_298_4370)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_4370",
    x1: 4.73414,
    y1: 4.88458,
    x2: 18.4233,
    y2: 4.88458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_298_4370",
    x1: 0,
    y1: 13.7586,
    x2: 13.9668,
    y2: 13.7586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_298_4370",
    x1: 6.13608,
    y1: 20.0458,
    x2: 22.0035,
    y2: 20.0458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#282425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#535151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#979696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AFAEAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_298_4370",
    x1: 21.0428,
    y1: 5.65286,
    x2: 32.9801,
    y2: 11.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_298_4370",
    x1: 14.273,
    y1: 13.3569,
    x2: 34.675,
    y2: 13.3569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#393536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#666364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#8B898A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#A8A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_298_4370",
    x1: 21.1992,
    y1: 19.8203,
    x2: 35.209,
    y2: 22.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#403D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#727071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#9A9899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B6B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCDCD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.fb71c2329044ffd34cfad46ef5aac9bd.svg";
export { ForwardRef as ReactComponent };